import React from 'react';
import { motion } from 'framer-motion';

export const TopBanner = () => {
  return (
    <div className="bg-primary text-primary-foreground py-3 px-4 text-center">
      <p className="text-sm font-medium tracking-wide">
        Official Xtreamcube services gate
      </p>
    </div>
  );
};